import { render, staticRenderFns } from "./PermissionTransportSpecialistExporter.vue?vue&type=template&id=32e7556d&scoped=true"
import script from "./PermissionTransportSpecialistExporter.vue?vue&type=script&lang=js"
export * from "./PermissionTransportSpecialistExporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7556d",
  null
  
)

export default component.exports